<template>
  <!-- 专家库 -->
  <div class="box one-list ExpertDatabase">
    <details-head img="./img/bj4.png" title="专家库" remarks="Expert Database" />
    <TopBreadcrumb :data="[{ label: '数据开放' }, { label: '专家库' }]" />
    <div class="con" v-loading="loading">
      <!-- 搜索框 -->
      <!-- <SearchName :name.sync="titleSelect"  @select="select()" /> -->
      <!-- <div class="list">
        <div class="item" v-for="(item, i) in list" :key="i" @click="$router.push({ name: 'ExpertDatabaseSee', params:{id:item.id} })">
          <img src="@/assets/icon/new.png" alt="" />
          <div>
            <div class="title">{{item.fullName}}</div>
            <div class="remarks" v-text="'职位：'+$textyc($html2text(item.jobTitle), 200)"></div>
          </div>
        </div>
        <div class="kong" v-if="!list || list.length == 0">数据为空</div>
      </div> -->

      <!-- <div class="moer" v-if="list.length < total">
        <div @click="onAddList">加载更多</div>
      </div> -->

      <el-collapse v-model="activeNames">
        <el-collapse-item :title="item.lable + `（${list[item.value] && list[item.value].length || '0'}人）`"
          :name="item.value + ''" v-for="item in expertDatabaseType" :key="item.value">
          <div class="ExpertSub" style="display: block;">
            <div class="LeadershipFlexH">
              <h2 style="width: 7.2%;">序号</h2>
              <h2 style="width: 31%;">单位</h2>
              <h2 style="width: 9.7%;">姓名</h2>
              <h2 style="width: 7.2%;">性别</h2>
              <h2 style="width:24.7%;">职务</h2>
              <h2 style="width:17%;">职称</h2>
            </div>
            <div class="PersonalCont">
              <h2 style="width: 100%;" v-if="!list[item.value] || list[item.value].length == 0">数据为空</h2>
              <div class="LeadershipFlexH" v-for="dat, i in list[item.value]" :key="dat.id">
                <h2 style="width: 7.2%;"><i>{{ i + 1 }}</i></h2>

                <el-tooltip effect="dark" v-if="dat.unitName && dat.unitName.length > 16" :content="dat.unitName" placement="top">
                  <h2 style="width: 31%;"><i>{{ $textyc(dat.unitName, 16) }}</i></h2>
                </el-tooltip>
                <h2 style="width: 31%;" v-else><i>{{ dat.unitName || '——' }}</i></h2>

                <h2 style="width: 9.7%;"><i>{{ dat.fullName || '——' }}</i></h2>
                <h2 style="width: 7.2%;"><i>{{ dat.gender == 0 ? '男' : (dat.gender == 1 ? '女' : '——') }}</i></h2>

                <el-tooltip effect="dark" v-if="dat.jobPosition && dat.jobPosition.length > 14" :content="dat.jobPosition" placement="top">
                  <h2 style="width:24.7%;"><i>{{ $textyc(dat.jobPosition, 14) }}</i></h2>
                </el-tooltip>
                <h2 style="width:24.7%;" v-else><i>{{ dat.jobPosition || '——' }}</i></h2>

                <el-tooltip effect="dark" v-if="dat.jobName && dat.jobName.length > 9" :content="dat.jobName" placement="top">
                  <h2 style="width:17%;"><i>{{ $textyc(dat.jobName, 9) }}</i></h2>
                </el-tooltip>
                <h2 style="width:17%;" v-else><i>{{ dat.jobName || '——' }}</i></h2>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { expertDatabaseType } from "@/utils";
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import SearchName from "../comp/SearchName.vue";
import { expert } from "@/api/dataOpen.js";
const { pageQuery, frontList } = expert
export default {
  components: { DetailsHead, TopBreadcrumb, SearchName },
  data() {
    return {
      expertDatabaseType,
      titleSelect: "",

      total: 1,
      page: 1,
      size: 10,

      list: [],
      loading: false,

      activeNames: []
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    onAddList() {
      this.select(true);
    },

    select(isAdd) {
      this.loading = true;

      frontList().then(res => {
        this.list = res.data
        console.log(res);
      }).finally(() => {
        this.loading = false;
      });


      // if (!isAdd) this.page = 1
      // else this.page++;
      // pageQuery({
      //   page: this.page,
      //   size: this.size,
      //   name: this.titleSelect,
      // })
      //   .then((res) => {
      //     const { data } = res;
      //     this.total = data.total;
      //     // 是否重置列表
      //     if (!isAdd) this.list = []
      //     data.records.forEach((item) => {
      //       this.list.push(item);
      //     });
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
  },
};
</script>
 
<style lang="less" scoped>
@import url("../comp/css/one-list.less");
@import url("../comp/css/load-moer.less");

.con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.ExpertSub {
  margin-top: 6px;
  text-align: left;
  font-size: 24px;
  margin-bottom: 20px;
  float: left;
  width: 100%;
  display: block;

  h2 {
    float: left;
    height: 56px;
    text-align: center;
    background-color: #f2f2f2;
    margin-bottom: 4px;
    // margin-right: 5px;
    position: relative;
    font-size: 17px;
    color: #000;
    line-height: 56px;
    width: 7.2%;
    overflow: hidden;
    white-space:nowrap;
  }

  .LeadershipFlexH {
    text-align: left;
    display: flex;
    justify-content: space-between;

    h2 {
      font-weight: bold;
    }
  }

  .PersonalCont {
    text-align: left;

    .LeadershipFlexH {
      h2 {
        font-weight: normal;
      }
    }
  }
}
</style>
<style lang="less">
.ExpertDatabase {
  .el-collapse {
    border: none;
  }

  .el-collapse-item {
    margin-top: 6px;
  }

  .el-collapse-item__header {
    background-color: #f2f2f2;
    font-size: 20px;
    // font-weight: bold;
    padding-left: 10px;

    &.is-active {
      font-weight: bold;
    }
  }

  .el-collapse-item__wrap {
    border: none;
  }
}
</style>